import React from 'react'
import {  Grid, Image } from 'semantic-ui-react';
import {Container} from 'semantic-ui-react';
import { useSelector} from 'react-redux';
import { db } from "../../../firebase";
import axios from "axios";
import {Card} from '@mui/material';
import { CircularProgress } from '@mui/material'
import { useDispatch } from 'react-redux';
import useGlobalConfig from '../../../hooks/globalConfig'
import DropzoneAreaSeccion from '../../../components/DropzoneArea';
import SimpleDialog from '../../../components/SimpleDialog';
import {updateCompanybillingAccount} from '../../../redux/accionesCompanies'
require('dotenv').config()

const Validacionbilling = (props) => {
    //// console.log(props)
    const dispacht = useDispatch()
    const userUid = useSelector(store => store.usuario.user.uid);
    // // console.log(props.match.params.company)
    // // console.log(props.match.params.id)
    var company= props.match.params.company
    var id=  props.match.params.id
    const {purchaseState } = useGlobalConfig()
    const [autorize,setAutorize]= React.useState(null)
    const [productoDetails, setProductoDetails] = React.useState("")
    const [response, setresponse] =React.useState("")

    const [session, setSession] = React.useState("")
    const [assignCompany,setAssignCompany]= React.useState("")
    const [carContent, setCarContent] = React.useState("")
    const [payMethodsId, setPayMethodsId] =React.useState("")
    const [statusLabel,setStatusLabel] = React.useState("")
    const [typebilling,setTypebilling] = React.useState("")
    const [toogle, setTogle] = React.useState(false)

 

    React.useEffect(() => {
        if (userUid) {
          obtenerDatosdeCliente(userUid);
          
        }
      }, []);   

      React.useEffect(() => {
        if (session.userCompanyID) {
        if(session.roll === 'biccixpressAdmin'){ 
            getData(company,id)
        }else{
            setAutorize(false)
        }
        }
      }, [session, toogle]);   

      const obtenerDatosdeCliente = async (userUid) => {
        try {
        const accountants = await db.collection(`${process.env.REACT_APP_COL_USERS}`).doc(userUid).get();
        var data = accountants.data();
        setSession(data);
        const companiesaccountants = await db
            .collection(`${process.env.REACT_APP_COL_COMPANIES}`)
            .doc(data.userCompanyID)
            .get();
        var dataComp = companiesaccountants.data();
        //// console.log(dataComp);
        if (dataComp) {
            setAssignCompany(dataComp);
        } else {
            setAssignCompany("");
        }
        } catch (error) {}
    };


        const getData = async (companyid,id) =>{
          // console.log('ejecucion test api')
          const company = {
              method:'getBil',
              companyId:companyid,
              documentId:id,
          }
    
          const response = await axios.post('http://localhost:5000/bicci-dev-c842f/us-central1/billincompany/', company, {      // Desarrollo
              headers: {
                'Content-Type': 'application/json' 
                }
              }); 
          // console.log('Respuesta')    
          // console.log(response.data)
          setresponse(response.data)
          setProductoDetails(response.data.carContent)
          setCarContent(response.data.carContent)
          setPayMethodsId(response.data.payMethod)
          setStatusLabel(response.data.statusLabel)
       //   setTypebilling(response.data.typebilling)
          // console.log(response)
            if(response.data){
              setAutorize(true)
            }else{
              setAutorize(false)
            }
          
          //props.history.push('/404')
       
  
        }
        const handleChageState = async (id,statusLabel) =>{
          // console.log(id)
          await db.collection(`${process.env.REACT_APP_COL_SUMARIES}`).doc(`${props.match.params.id}`).update({
            "purchaseState":id,
            "statusLabel":statusLabel,
          });
          await setTogle(!toogle)
          // console.log(response)
          dispacht(updateCompanybillingAccount(response))
        }


// // console.log(response)
// // console.log(response.carContent)
  return autorize===true?(
      <div>
        <Container >
            <Grid celled='internally'>
                    <div className='resumenOrdenesContainer'>
                    <div className='resumenOrdenesContent'>
                    <Card  className="card-ultimasOrdenes typeMiniforms resumenOrdenes">
                     <h1>Gestion de validacion de ordenes</h1>
                     
                     <div>
                         <Grid.Row className='card-container'>
                         <Grid.Column  computer={4} mobile={16} tablet={16} className="ebiex-iphone12 ebiex-iphone12-l">

                         <article className="cardarticle cardarticle-checout">
                          <h5>Documento o Imagen para confirmación de transferencia:</h5>
                          <div className="mb-4">
                          <div>
                                     <Image
                                        className="checkoutImages-scuale"
                                        src={response.urlTransferEvidence}
                                      />
                                     </div>      
                          </div>
                         </article>
                         <article className="cardarticle cardarticle-checout">
                         <h2>Detalles del pedido:</h2>
                         <div className="row-tab-checkout">
                                        <div>Estado</div>
                                        <div className="row-tab-checkout-letf">
                                       <h3>{purchaseState[response.purchaseState]}</h3></div>
                                      </div>
                                      <hr></hr>
                                      <div className="row-tab-checkout">
                                        <div>  numero de solicitud :</div>
                                        <div className="row-tab-checkout-letf">
                                         
                                          <span className="h3">{response.buyOrderId}</span>                                         
                                        </div>
                                      </div>
      
                                      <div>
                                        <hr></hr>
                                        <div className="row-tab-checkout">
                                          <div>  Fecha: </div>
                                          <div className="row-tab-checkout-letf">
                                          <span >{response.createdateAdd}</span> 
                                          </div>
                                        </div>
                                      </div>
                                      <hr></hr>
                         <div className="row-tab-checkout-right">
                            
                             <div>
                                     <Image
                                        className="checkoutImages"
                                        src="https://firebasestorage.googleapis.com/v0/b/bicci-7ed2f.appspot.com/o/webfrontend%2Fweb-bicciexpress%2FIconos-03.png?alt=media&token=bdff97b1-1471-4c59-a142-327e59c0b9ff"
                                      />
                                     </div>
                                      <div className="title row-tab-checkout-display-block">
                                         Producto o servicios:<br></br>
                                         {
                                           productoDetails.map(item => (<div key={item.id} className="row-tab-checkout-right letf">{item.productName}<br></br> </div>) )
                                         }
                                        {/* <h3>{productoDetails.productName}</h3> */}
                                      </div>
                                      </div>
                                      <hr></hr>
                                      <div className="row-tab-checkout">
                                        <div>Precio</div>
                                        <div className="row-tab-checkout-letf">
                                     
                                                                                
                                        {Intl.NumberFormat("es-CL", {
                                              style: "currency",
                                              currency: "CLP",
                                              minimumFractionDigits: 0,
                                            }).format(
                                              response.TotalOrder
                                            )} 
                                          
                                        </div>
                                      </div>
                                      <hr></hr>
                                      <div className="row-tab-checkout">
                                        <div>Costo de envío</div>
                                        <div className="row-tab-checkout-letf">
                                         
                                        {Intl.NumberFormat("es-CL", {
                                              style: "currency",
                                              currency: "CLP",
                                              minimumFractionDigits: 0,
                                            }).format(
                                              response.totalShipping
                                            )}
                                         
                                        </div>
                                      </div>
                                      <div>
                                        <hr></hr>
                                        <div className="row-tab-checkout">
                                          <div>  Descuento </div>
                                          <div className="row-tab-checkout-letf">
                                          <span className="h3">
 
                                             {Intl.NumberFormat("es-CL", {
                                              style: "currency",
                                              currency: "CLP",
                                              minimumFractionDigits: 0,
                                            }).format(
                                              response.discount
                                            )} 

                                            </span>
                                          </div>
                                        </div>
                                      </div>
 
                                      <div>
                                        <hr></hr>
                                        <div className="row-tab-checkout">
                                          <div>  Total a pagar </div>
                                          <div className="row-tab-checkout-letf">
                                          <span className="h3">
 
                                             {Intl.NumberFormat("es-CL", {
                                              style: "currency",
                                              currency: "CLP",
                                              minimumFractionDigits: 0,
                                            }).format(
                                              response.paidAmount
                                            )} 

                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <hr></hr>
                                        <div className="row-tab-checkout">
                                          <div>  Pendiente por pago </div>
                                          <div className="row-tab-checkout-letf">
                                          <span className="h3">
 
                                             {Intl.NumberFormat("es-CL", {
                                              style: "currency",
                                              currency: "CLP",
                                              minimumFractionDigits: 0,
                                            }).format(
                                              response.paidAmount
                                            )} 

                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <hr></hr>
                                        <div className="row-tab-checkout">
                                          <div>  Metodo de Pago </div>
                                          <div className="row-tab-checkout-letf">
                                          {
                                            response.payMethods?(<>{response.payMethods}</>):(<></>)
                                          }
                                          
                                          </div>
                                        </div>
                                      </div>
                                      <hr></hr>
                                  
                                      <div className="row-tab-checkout">
                                          <div>  Preferencia de Facturación </div>
                                          <div className="row-tab-checkout-letf">
                                          <span>{response.typebilling}</span>
                                        </div>
                                      </div>
                                  
                                   
                                                                      
                                      <div className="mb-4">
                                  
                                      </div>
                                    </article>
                                    <br></br>
                         </Grid.Column>
                         <Grid.Column  computer={4} mobile={16} tablet={16} className="ebiex-iphone12 ebiex-iphone12-r" >
                         <article className="cardarticle cardarticle-checout cardarticle-sussces">
                         <h4>Editar estado tras confirmación de documento:</h4>
                                      <hr></hr>
                                      {
                                        response?( <SimpleDialog estadoActual={response.purchaseState} handleChageState={handleChageState}></SimpleDialog>    ):('')
                                      }
                                     

                                      <DropzoneAreaSeccion documentId={props.match.params.id}/>
                                   
                                      <div>
                                        <hr></hr>
                                        <div className="row-tab-checkout">
                                          <div>  Monto pendiente  </div>
                                          <div className="row-tab-checkout-letf">
                                            <span className="h3">
                                             {Intl.NumberFormat("es-CL", {
                                              style: "currency",
                                              currency: "CLP",
                                              minimumFractionDigits: 0,
                                            }).format(
                                                response.paidAmount
                                            )} </span> 
                                          </div>
                                        </div>
                                      </div>
                                      <hr></hr>
                                      <h3>
                                        Numero de envíos incluidos:
                                      </h3>
                                      <span className="h1">
                                      { response.ChargeShipments}</span>
                                      <hr />
                                                                      
                                      <div className="mb-4">
                                  
                                      </div>
                                    </article>
                                    <button  onClick={() => props.history.push('/billing') } className="btn btn-ebiex btn-globalhover m-1">Regresar a Ordenes</button>
                         </Grid.Column>

                         </Grid.Row>
                     </div>
                     <br></br>
                     <Grid.Row>
                      {
                        response.purchaseState>=0 && response.purchaseState<=2?(<>
                           <article className="cardarticle cardarticle-checout">
                     <div className="ui-seller-info card-article-center">
                                            <div className="seller_header-foot">
                                              <div className="ui-pdp-seller__header__image-container"></div>
                                              <div className="ui-pdp-seller__header__info-container">
                                                <div className="ui-pdp-seller__header__title">
                                                  Confirmación de la transferencia a cuenta empresa
                                                </div>
                     <button onClick={() => window.location = 'mailto:contacto@bicciexpress.cl'} className="btn btn-ebiex btn-globalhover m-1"> Enviar recibo por email</button>
                     <button  onClick={() => props.history.push('/mi-cuenta') } className="btn btn-ebiex btn-globalhover m-1"> Mi cuenta</button>
                                           
                                              </div>
                                            </div>
                                          </div>
                     {/* <button  className="btn btn-ebiex btn-globalhover m-1"> Subir imagen de pago</button > */}
                     </article>

                        </>):(<></>) 
                      }
                      {
                        response.purchaseState>=3 && response.purchaseState<=4?(<>Procesando </>):(<></>) 
                      }
                      {
                        response.purchaseState===5?(<>Finalizado</>):(<></>) 
                      }
                  
                                    </Grid.Row>
                    
                     
                     
                     </Card>
                     </div>
                    </div>
           </Grid>
        </Container> 
      </div>
       ):(<>
         <Container >         
         <Grid celled='internally'>
         <div className='center-alert'>
         <Card  className="card-ultimasOrdenes typeMiniforms resumenOrdenes">
            {
            autorize===false?(<> <h3>No se encontraron resultados</h3>
            <span className="alert alert-danger ">
            El Id es incorrecto, No es propietario de esta empresa o no tiene permisos de usuario para ver el documento</span>
            </>):(<CircularProgress />)
                  }
                  </Card>
                  </div>
        </Grid>
        </Container> 
       </>)
        
        
     
    

}

export default Validacionbilling